
import React, { useState, useContext } from 'react'
import { AnimatePresence, motion } from "framer-motion";
import { isMobileContext } from '../../contexts/isMobileContext';
import { useRouter } from 'next/router';
import { Navigation, Pagination, EffectFade, Mousewheel } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import CollaborationsCard from './CollaborationsCard';
import Image from 'next/image';
import FadeIn from '../Animations/FadeIn';
import Magnitizer from '../Animations/Magnitizer';
const Collaborations = ({ collaborations }) => {
    const { locale } = useRouter()
    const { isMobile } = useContext(isMobileContext);
    const [slideNumber, setSlideNumber] = useState('0' + 1)
    return (
        <div className='collaborations-section'>
            <div className='bg'>
                <div className='img-container'>
                    <Image
                        alt='bg'
                        src={"/icons/logo-background.svg"}
                        layout="fill"
                        objectFit='cover'
                    />
                </div>
            </div>
            <FadeIn customClass='header'>
                <h2 className='light _eleX'>{collaborations?.Header}</h2>
            </FadeIn>
            <FadeIn customClass='swiper-container'>
                <Swiper
                    key={"collaborations" + collaborations?.Our_Collaborations?.length}
                    style={{ direction: locale == "ar" ? "rtl" : "ltr" }}
                    modules={[
                        Navigation,
                        Pagination,
                        EffectFade,
                        Mousewheel,
                    ]}

                    navigation={{
                        nextEl: ".swiper-button-next-collaborations",
                        prevEl: ".swiper-button-prev-collaborations",
                    }}
                    pagination={{
                        type: "progressbar",
                        el: ".swiper-collaborations-navigation",
                    }}
                    className="swiper-collaborations-section"
                    slidesPerView={1}
                    spaceBetween={20}
                    onSlideChange={(swiper) => { setSlideNumber('0' + (swiper.realIndex + 1)) }}
                    breakpoints={{
                        768: {
                            slidesPerView: 2,
                            spaceBetween: 20,
                        },
                        1024: {
                            slidesPerView: 1.25,
                            spaceBetween: 40,
                        },
                    }}
                // loop={true}
                >
                    {collaborations?.Our_Collaborations?.map((data, index) => (
                        <SwiperSlide key={index}>
                            <CollaborationsCard cardData={data} index={index} />
                        </SwiperSlide>
                    ))}
                </Swiper>
                <div className={`swiper-navigation-continer
                            ${collaborations?.Our_Collaborations?.length < 2 && "d-none"}
                            ${isMobile && collaborations?.Our_Collaborations?.length < 3 && "d-none"}
                            `}>
                    <div className="navigation-container">
                        <div className="slide-number-container bold">
                            <div>{slideNumber}</div>
                            <div>{"0" + collaborations?.Our_Collaborations?.length}</div>
                        </div>
                        <div className="swiper-collaborations-navigation swiper-pagination-progressbar"></div>
                    </div>
                    <div className="arrows-container">
                        <Magnitizer dataDest={1.5}>
                            <div className="swiper-button-prev swiper-button-prev-collaborations collaborations-arrow"
                            ></div>
                        </Magnitizer>
                        <Magnitizer dataDest={1.5}>
                            <div className="swiper-button-next swiper-button-next-collaborations  collaborations-arrow"
                            ></div>
                        </Magnitizer>
                    </div>
                </div>
            </FadeIn>
        </div>
    )
}

export default Collaborations
